import { c as _c } from "react/compiler-runtime";
import { ArrowDownLeftIcon, ArrowUpRightIcon } from "@heroicons/react/24/solid";
import type { RepDirection } from "./UserPageRep.helpers";
export default function RepDirectionToggle(t0) {
  const $ = _c(21);
  const {
    repDirection,
    onRepDirectionChange,
    compact
  } = t0;
  const iconClass = compact ? "tw-h-3 tw-w-3 tw-flex-shrink-0" : "tw-h-3.5 tw-w-3.5 tw-flex-shrink-0";
  const textClass = compact ? "tw-text-xs" : "tw-text-[13px]";
  const activeExtra = compact ? "tw-font-semibold" : "";
  const t1 = repDirection === "received";
  let t2;
  if ($[0] !== onRepDirectionChange) {
    t2 = () => onRepDirectionChange("received");
    $[0] = onRepDirectionChange;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `tw-inline-flex tw-cursor-pointer tw-items-center tw-gap-1.5 tw-border-0 tw-bg-transparent tw-p-0 ${textClass} tw-font-medium tw-transition-colors tw-duration-200 ${repDirection === "received" ? `tw-text-iron-100 ${activeExtra}` : "tw-text-iron-500 hover:tw-text-iron-300"}`;
  let t4;
  if ($[2] !== iconClass) {
    t4 = <ArrowDownLeftIcon className={iconClass} aria-hidden="true" />;
    $[2] = iconClass;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t1 || $[5] !== t2 || $[6] !== t3 || $[7] !== t4) {
    t5 = <button type="button" aria-pressed={t1} onClick={t2} className={t3}>{t4}Received</button>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = repDirection === "given";
  let t7;
  if ($[9] !== onRepDirectionChange) {
    t7 = () => onRepDirectionChange("given");
    $[9] = onRepDirectionChange;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = `tw-inline-flex tw-cursor-pointer tw-items-center tw-gap-1.5 tw-border-0 tw-bg-transparent tw-p-0 ${textClass} tw-font-medium tw-transition-colors tw-duration-200 ${repDirection === "given" ? `tw-text-iron-100 ${activeExtra}` : "tw-text-iron-500 hover:tw-text-iron-300"}`;
  let t9;
  if ($[11] !== iconClass) {
    t9 = <ArrowUpRightIcon className={iconClass} aria-hidden="true" />;
    $[11] = iconClass;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t6 || $[14] !== t7 || $[15] !== t8 || $[16] !== t9) {
    t10 = <button type="button" aria-pressed={t6} onClick={t7} className={t8}>{t9}Given</button>;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t5) {
    t11 = <div className="tw-flex tw-items-center tw-gap-4">{t5}{t10}</div>;
    $[18] = t10;
    $[19] = t5;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
}